import { isSelectionCheckGuidelinesAllowed } from '@/helpers/is-check-guidelines-allowed';
import { cn } from '@/lib/cn';
import { dropdownMenuItemVariants } from '@heidi/design-system/dropdown-menu';
import { type Editor } from '@tiptap/react';
import { COMPACT_MENU_ACTIONS } from './selection-ai-actions.config';

export { isSelectionCheckGuidelinesAllowed };

export const getVisibleCompactMenuActions = () =>
  COMPACT_MENU_ACTIONS.filter(
    ({ id }) => id !== 'check_guidelines' || isSelectionCheckGuidelinesAllowed()
  );

/** Visible preset rows plus the Ask to edit field, for the menu-shown event. */
export const getCompactMenuSuggestionCount = () =>
  getVisibleCompactMenuActions().length + 1;

export const ACTION_ROW_CLASS = cn(
  dropdownMenuItemVariants(),
  'w-full text-start text-text-primary'
);

export interface SelectionEditorActions {
  enableFindReplace: boolean;
  enableSnippet: boolean;
  enableConvertToSection: boolean;
  onFindReplace: () => void;
  onCreateSnippet: () => void;
  onConvertToSection: () => void;
}

interface ActionTarget {
  from: number;
  to: number;
  text: string;
}

export const resolveSelectionActionTarget = (
  editor: Editor,
  getTargetRange?: () => { from: number; to: number } | null
): ActionTarget | null => {
  const range = getTargetRange
    ? getTargetRange()
    : { from: editor.state.selection.from, to: editor.state.selection.to };
  if (!range) return null;
  const text = editor.state.doc.textBetween(range.from, range.to, '\n').trim();
  return text ? { ...range, text } : null;
};
